import axios from "axios";
import configure from "configure";


export const axiosNodeInstance = axios.create({
    baseURL: `${configure?.apiUrl}`,
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
    },
});

export const fetchNodeData = async (toggleLoading, apiName, token) => {
    try {
        toggleLoading(true);
        const res = await axiosNodeInstance.get(`/${apiName}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        toggleLoading(false);
        return res.data
    } catch (error) {
        console.error(error);
        toggleLoading(false);
    }
}

export const FetchNodePostData = async (toggleLoading, apiName, token, formDataEntries) => {
    try {
        toggleLoading(true);
        const formData = new FormData();
        for (const [key, value] of Object.entries(formDataEntries)) {
            formData.append(key, value);
        }
        const res = await axiosNodeInstance.post(`${apiName}`, formDataEntries, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        toggleLoading(false);
        return res
    } catch (error) {
        console.error(error);
        toggleLoading(false);
    }
}
// PUT - Update
export const FetchNodePutData = async (toggleLoading, nodeUrl, id, formDataEntries) => {
    try {
        toggleLoading(true);
        const res = await axiosNodeInstance.put(`/${nodeUrl}/${id}`, formDataEntries, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        toggleLoading(false);
        return res;
    } catch (error) {
        console.error(error);
        toggleLoading(false);
    }
};